import { ProposedSolutionCardsFullScreen } from "..";
import { ChosenDilemmaCard } from "../../molecules/Board/subBoardComponents";
import { TeamContext } from "../../../context";
import { useContext } from "react";
import { IPlayer } from "../../../interfaces";
import instructionArrow from "../../../assets/icons/instructionArrow.svg";
import { useTranslation } from "react-i18next";

const ChoosingProposedSolutionCardsFullScreen = () => {
    const { t } = useTranslation();
    const { game } = useContext(TeamContext);
    const dilemmaOwner = game?.players.find((player: IPlayer) => { return game.gameInfo.currentPlayerEmail === player.email });
    
    return (
        <div className="dilemma_owner_anouncement_wrapper choosing_proposed_solution_cards_full_screen center_horizontally_and_vertically full_screen_vw_vh">
            <div className="choosing_proposed_solution_cards_full_screen_title_1"> {t("suggestedSolutionCardsText") || "text missing"} </div>
            <div className="gradient_line_holder center_horizontally_and_vertically" style={{height: "3vh", width: "60%"}}>
                <div className="linear_gradient_line_horizontal" style={{ width: "100%" }}></div>
            </div> 
            <div className="choosing_proposed_solution_cards_full_screen_title_2"> {t("solutionOwnerPleasePitchYourSolutionCardText") || "text missing"} </div>
            <ProposedSolutionCardsFullScreen />    
            <div className="gradient_line_holder center_vertically" style={{ width: "60%"}}>
                <div className="linear_gradient_line_horizontal" style={{ width: "100%" }}></div>
            </div>  
            <div className="choosing_proposed_solution_cards_full_screen_dilemma_card_wrapper"> 
                <div className="choosing_proposed_solution_cards_full_screen_dilemma_empty_div"></div>
                <div className="choosing_proposed_solution_cards_full_screen_dilemma_card">
                    <ChosenDilemmaCard isFullScreenOn={true} isTheFullScreenOn={true} />
                </div>
                <div className="choosing_proposed_solution_cards_full_screen_dilemma_instruction"> 
                    <div className="dilemma_owner_anouncement_text_big" style={{fontSize: "large", marginLeft:"-10px"}}>
                        {t("whenPlayersAreFinishedWithTheirPitches_Text") || "text missing"}
                        <div className="dilemma_owner_anouncement_text_big">
                        <span className={"text_color_"+dilemmaOwner?.color}> {dilemmaOwner?.nickname} </span>
                        {t("dilemmaOwnerName_pleaseChooseChooseTheSolutionThatMostSuitsYouText") || "text missing"}</div>
                        <div className="dislay_flex">
                            {t("thatSuitsYou")}
                            <div className="instruction_arrow_wrapper">
                                <div className="margin_left_10 bracet">(</div>
                                <img className="dilemma_choosing_solutions_arrow" src={instructionArrow} alt="instructionArrow" />
                                <div className="bracet">)</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>      
    )
}

export default ChoosingProposedSolutionCardsFullScreen;